import Page from "@/components/pages/inventory/product-model/page";
import { createFileRoute } from "@tanstack/react-router";
import 'react-inner-image-zoom/lib/styles.min.css'
import { withRouteProtection } from "@/lib/router/route-protection";
import { SECTION_PROTECTION, PROTECTION_PRESETS } from "@/lib/router/protection-presets";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const searchSchema = z.object({
	productModelId: z.string().optional(),
	type: z.enum(["edit", "add"]).optional(),
	needRefresh: z.boolean().optional(),
}).optional();


export const Route = createFileRoute("/_app/inventory/product-model/_modal/")({
	component: Page,
	validateSearch: zodValidator(searchSchema),
	// ...withRouteProtection(PROTECTION_PRESETS.PROJECT_VIEW),
});
